{
  "name": "argon",
  "version": "2026.06.30",
  "packageManager": "npm@11.18.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --no-watch --no-progress --browsers=ChromeHeadless",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.3",
    "@angular/cdk": "^21.1.3",
    "@angular/common": "^21.1.3",
    "@angular/compiler": "^21.1.3",
    "@angular/core": "^21.1.3",
    "@angular/forms": "^21.1.3",
    "@angular/material": "^21.1.3",
    "@angular/platform-browser": "^21.1.3",
    "@angular/platform-browser-dynamic": "^21.1.3",
    "@angular/router": "^21.1.3",
    "@azure/msal-angular": "^4.0.2",
    "@azure/msal-browser": "^4.0.2",
    "@scania/tegel": "^1.32.0",
    "@scania/tegel-angular-17": "^1.32.0",
    "body-scroll-lock": "^4.0.0-beta.0",
    "bootstrap": "^5.3.8",
    "chart.js": "^4.5.0",
    "gsap": "^3.13.0",
    "ng2-charts": "^4.1.1",
    "rxjs": "~7.8.0",
    "three": "^0.177.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.3",
    "@angular-devkit/build-angular": "^21.1.3",
    "@angular/cli": "^21.1.3",
    "@angular/compiler-cli": "^21.1.3",
    "@types/body-scroll-lock": "^3.1.2",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^24.1.0",
    "@types/three": "^0.177.0",
    "angular-eslint": "19.0.2",
    "eslint": "^9.16.0",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.55.0"
  }
}
